import { getAlsConfig } from './getAlsConfig';

export const alsConfig = {
  getAlsConfig,
};
